import { useClock } from "./index.js";

export const useTournamentClock = ({
  start,
  end,
}: {
  start: number;
  end: number;
}) => {
  const now = useClock();
  const startDiff = start - now;
  const endDiff = end - now;

  const status =
    !start || !end
      ? undefined
      : endDiff < 0
        ? "completed"
        : startDiff < 0
          ? "running"
          : "pending";

  return [status, { now, startDiff, endDiff }] as const;
};
